import { Component, ProviderToken, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { connectState } from '@examdojo/angular/util';
import { HandleEmailVerifiedService } from '@examdojo/auth';
import { environment } from '@examdojo/core/environment';
import { PosthogErrorHandlingService } from '@examdojo/core/posthog';
import { LoaderComponent } from '@examdojo/ui/loader';
import { AuthService, UserQuery } from '@examdojo/user';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { first, map, startWith, tap } from 'rxjs';

@Component({
  selector: 'dojo-root',
  templateUrl: 'app.component.html',
  styleUrl: 'app.component.scss',
  imports: [IonApp, IonRouterOutlet, LoaderComponent],
})
export class AppComponent {
  constructor(
    private readonly userQuery: UserQuery,
    private readonly posthogErrorHandlingService: PosthogErrorHandlingService,
    private readonly authService: AuthService,
  ) {
    this.identifyPosthogUserWhenAuthenticated().pipe(takeUntilDestroyed()).subscribe();
  }

  private readonly instantiatedServices = [HandleEmailVerifiedService].map((service: ProviderToken<unknown>) =>
    inject(service),
  );

  readonly state = connectState({
    isLoading: this.authService.currentUser$.pipe(
      startWith(undefined), // Use undefined as the initial loading state
      map((currentUser) => currentUser === undefined),
    ),
  });

  private identifyPosthogUserWhenAuthenticated() {
    return this.userQuery.active$.pipe(
      first(Boolean),
      tap((user) => {
        this.posthogErrorHandlingService.identifyUser(user.id, {
          first_name: user.first_name,
          last_name: user.last_name,
          email: user.email,
          app_version: environment.release_version,
        });
      }),
    );
  }
}
